import { FEATURE_AUDIO_WAVEFORM_FOR_VIDEO_ITEM } from '../flags';
import { EditorStarterItem } from '../items/item-type';
import { hasEmbeddedLipsyncAudio } from '../items/video/video-item-type';
import { FILMSTRIP_HEIGHT_IF_THERE_IS_AUDIO } from '../timeline/timeline-item/timeline-item-film-strip';
import { WAVEFORM_HEIGHT } from '../timeline/timeline-item/timeline-item-waveform';
import { TrackType } from './types';

const DEFAULT_TRACK_HEIGHT = 48;
export const TRACK_DIVIDER_HEIGHT = 0;
export const TRACK_PADDING = 4;
const getItemHeight = (item: EditorStarterItem) => {
  if (item?.type === 'video') {
    return (
      FILMSTRIP_HEIGHT_IF_THERE_IS_AUDIO +
      2 +
      (FEATURE_AUDIO_WAVEFORM_FOR_VIDEO_ITEM || hasEmbeddedLipsyncAudio(item)
        ? WAVEFORM_HEIGHT
        : 0)
    );
  }
  if (item?.type === 'audio') {
    return FILMSTRIP_HEIGHT_IF_THERE_IS_AUDIO;
  }
  if (
    // 타입 안전성 확인, waveform이 없는 item type들을 여기에 추가
    item?.type === 'captions' ||
    item?.type === 'gif' ||
    item?.type === 'webp' ||
    item?.type === 'text' ||
    item?.type === 'solid' ||
    item?.type === 'blur' ||
    item?.type === 'image' ||
    item?.type === 'pdf' ||
    item?.type === 'ppt' ||
    item?.type === 'code' ||
    item?.type === 'group'
  ) {
    return DEFAULT_TRACK_HEIGHT;
  }

  throw new Error('Invalid item type: ' + (item satisfies never));
};

export const getTrackHeight = ({
  track,
  items,
}: {
  track?: TrackType;
  items: Record<string, EditorStarterItem>;
}) => {
  if (!track || track?.items.length === 0) {
    return DEFAULT_TRACK_HEIGHT + TRACK_PADDING;
  }

  return (
    track.items.reduce((acc, itemId) => {
      if (items[itemId]) {
        return Math.max(acc, getItemHeight(items[itemId]));
      }
      return acc;
    }, 0) + TRACK_PADDING
  );
};
